module.exports = __webpack_public_path__ + "static/bullywug-a6088f1eaa1410afec4d9145c5ebe2e2.png";